import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const LazyLoopResponseSectionLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-loopresponsesection" */ "./LoopResponseSection")).then((bundle)=>{
        return {
            default: bundle.LoopResponseSection
        };
    });
export const LazyLoopResponseSection = /*#__PURE__*/ lazy(LazyLoopResponseSectionLazyLoader);
